import { createRoute, redirect } from '@tanstack/react-router'
import { store } from 'src/store/store'
import { z } from 'zod'

import OrderYarcheGuestCreatePage from '../pages/OrderYarcheGuestCreatePage'
import { orderYarcheGuestRoute } from './OrderYarcheGuestRoute'

export const orderYarcheGuestCreateRoute = createRoute({
  beforeLoad: async () => {
    const { token } = store.getState().authReducer

    if (token) {
      throw redirect({
        to: '/order/create'
      })
    }
  },
  getParentRoute: () => orderYarcheGuestRoute,
  component: () => <OrderYarcheGuestCreatePage />,

  path: '/create',
  validateSearch: (search) =>
    z
      .object({
        data: z.string().optional()
      })
      .parse(search)
})
